// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global resets to prevent overflow */
* {
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
}

.text-page-container {
  width: 100%;
  height: 100vh;
  background: linear-gradient(135deg, #f8fafb 0%, #e8f0fe 100%);
  padding: 24px 24px 24px 24px;
  box-sizing: border-box;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.text-page-content {
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(228, 232, 241, 0.6);
  width: 100%;
  height: 100%;
  padding: 24px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.page-header {
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 2px solid rgba(102, 126, 234, 0.1);
  text-align: center;
  flex-shrink: 0;
}

.page-header h1 {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1a202c;
  margin: 0 0 12px 0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.page-header p {
  font-size: 1.1rem;
  color: #64748b;
  margin: 0;
  font-weight: 500;
}

.content-section {
  margin-bottom: 32px;
}

.content-section h2 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e2e8f0;
}

.content-section p {
  font-size: 1rem;
  line-height: 1.7;
  color: #4a5568;
  margin-bottom: 16px;
}

.feature-list, .impact-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.feature-list li, .impact-list li {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border: 1px solid rgba(226, 232, 240, 0.6);
  border-radius: 12px;
  padding: 16px 20px;
  margin-bottom: 12px;
  font-size: 0.95rem;
  line-height: 1.6;
  color: #2d3748;
  position: relative;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.feature-list li::before {
  content: '✓';
  position: absolute;
  left: -8px;
  top: 16px;
  width: 24px;
  height: 24px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 0.8rem;
}

.feature-list li:hover, .impact-list li:hover {
  background: linear-gradient(135deg, #e6fffa 0%, #e0f2fe 100%);
  border-color: #38b2ac;
  transform: translateX(4px);
  box-shadow: 0 4px 16px rgba(56, 178, 172, 0.15);
}

.impact-list li::before {
  content: '→';
  position: absolute;
  left: -8px;
  top: 16px;
  width: 24px;
  height: 24px;
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  border-radius: 50%;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 1rem;
}

.best-practices {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
  margin-top: 20px;
}

.practice-card {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border: 1px solid rgba(226, 232, 240, 0.8);
  border-radius: 16px;
  padding: 24px;
  text-align: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.practice-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #667eea 0%, #764ba2 50%, #f093fb 100%);
}

.practice-card:hover {
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  border-color: #0ea5e9;
  transform: translateY(-4px);
  box-shadow: 0 8px 32px rgba(14, 165, 233, 0.15);
}

.practice-card h3 {
  font-size: 1.2rem;
  font-weight: 600;
  color: #1a202c;
  margin: 0 0 12px 0;
}

.practice-card p {
  font-size: 0.9rem;
  color: #64748b;
  margin: 0;
  line-height: 1.5;
}

/* Scrollbar Styles */
.text-page-content::-webkit-scrollbar {
  width: 8px;
}

.text-page-content::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 10px;
}

.text-page-content::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);
  border-radius: 10px;
  border: 2px solid transparent;
  background-clip: content-box;
}

.text-page-content::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #cbd5e1 0%, #94a3b8 100%);
  background-clip: content-box;
}

/* Upload Section Styles */
.upload-section {
  margin-bottom: 32px;
  padding: 24px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-radius: 16px;
  border: 1px solid rgba(226, 232, 240, 0.8);
}

.upload-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.file-input-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.file-label {
  font-size: 1rem;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 8px;
}

.file-input {
  padding: 12px 16px;
  border: 2px dashed #cbd5e1;
  border-radius: 12px;
  background: white;
  font-size: 0.9rem;
  color: #4a5568;
  transition: all 0.3s ease;
  cursor: pointer;
}

.file-input:hover {
  border-color: #667eea;
  background: #f8fafc;
}

.file-input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.file-name {
  font-size: 0.9rem;
  color: #667eea;
  font-weight: 500;
  padding: 8px 12px;
  background: rgba(102, 126, 234, 0.1);
  border-radius: 8px;
  display: inline-block;
}

.submit-button {
  padding: 14px 28px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  align-self: flex-start;
}

.submit-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 32px rgba(102, 126, 234, 0.3);
}

.submit-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.error-message {
  color: #e53e3e;
  background: #fed7d7;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid #feb2b2;
  font-size: 0.9rem;
  margin-top: 12px;
}

.loading-container {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: linear-gradient(135deg, #e0f2fe 0%, #b3e5fc 100%);
  border-radius: 8px;
  margin-top: 12px;
}

.loading-spinner {
  width: 20px;
  height: 20px;
  border: 2px solid #e2e8f0;
  border-top: 2px solid #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Table Styles */
.table-container {
  background: white;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}


.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  flex-shrink: 0;
}

.table-header h3 {
  margin: 0;
  font-size: 1.3rem;
  font-weight: 600;
}

.record-count {
  font-size: 0.9rem;
  background: rgba(255, 255, 255, 0.2);
  padding: 6px 12px;
  border-radius: 20px;
  font-weight: 500;
}

.table-controls {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  flex-shrink: 0;
  flex-wrap: wrap;
  width: 100%;
  max-width: 100%;
}

.search-input {
  padding: 8px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 0.9rem;
  width: 100%;
  max-width: 300px;
  min-width: 200px;
  background: white;
  transition: border-color 0.2s ease;
}

.search-input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.record-info {
  font-size: 0.9rem;
  color: #64748b;
  font-weight: 500;
}

.table-wrapper {
  flex: 1 1;
  overflow: auto;
  min-height: 0;
  max-height: 100%;
}

/* Custom scrollbar for table wrapper */
.table-wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.table-wrapper::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 4px;
}

.table-wrapper::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);
  border-radius: 4px;
}

.table-wrapper::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #cbd5e1 0%, #94a3b8 100%);
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9rem;
  table-layout: auto;
}

.data-table th {
  background: #f8fafc;
  color: #2d3748;
  font-weight: 600;
  padding: 12px 16px;
  text-align: left;
  border-bottom: 2px solid #e2e8f0;
  position: sticky;
  top: 0;
  z-index: 10;
  white-space: nowrap;
  vertical-align: middle;
  box-sizing: border-box;
  max-width: 150px;
  text-transform: none;
}

.data-table td {
  padding: 12px 16px;
  border-bottom: 1px solid #f1f5f9;
  color: #4a5568;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
  text-align: left;
  box-sizing: border-box;
  max-width: 150px;
}

.data-table th,
.data-table td {
  border-left: none;
  border-right: none;
}

.data-table tr:hover {
  background: #f8fafc;
}

.data-table tr:nth-child(even) {
  background: #fafbfc;
}

.data-table tr:nth-child(even):hover {
  background: #f1f5f9;
}

.table-footer {
  padding: 16px 24px;
  background: #f8fafc;
  color: #64748b;
  font-size: 0.9rem;
  text-align: center;
  border-top: 1px solid #e2e8f0;
}

.no-data {
  padding: 40px;
  text-align: center;
  color: #64748b;
  font-size: 1rem;
}

/* Data Section Styles */
.data-section {
  margin-bottom: 16px;
  padding: 16px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-radius: 16px;
  border: 1px solid rgba(226, 232, 240, 0.8);
  flex-shrink: 0;
}

.success-message {
  color: #065f46;
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  padding: 16px 20px;
  border-radius: 12px;
  border: 1px solid #6ee7b7;
  font-size: 0.95rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 12px;
}

.success-message::before {
  content: '✓';
  width: 20px;
  height: 20px;
  background: #059669;
  border-radius: 50%;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 0.8rem;
  flex-shrink: 0;
}

/* ===== Dark theme overrides (light mode untouched) ===== */
[data-theme="dark"] .text-page-container {
  background: var(--app-bg);
}
[data-theme="dark"] .text-page-content {
  background: var(--surface);
  border-color: var(--border);
}
[data-theme="dark"] .page-header p,
[data-theme="dark"] .practice-card p,
[data-theme="dark"] .record-info,
[data-theme="dark"] .table-footer,
[data-theme="dark"] .no-data {
  color: var(--text-muted);
}
[data-theme="dark"] .content-section h2 {
  color: var(--text);
  border-bottom-color: var(--border);
}
[data-theme="dark"] .content-section p,
[data-theme="dark"] .file-label {
  color: var(--text-muted);
}
[data-theme="dark"] .feature-list li,
[data-theme="dark"] .impact-list li,
[data-theme="dark"] .upload-section,
[data-theme="dark"] .data-section {
  background: var(--surface-2);
  border-color: var(--border);
  color: var(--text);
}
[data-theme="dark"] .practice-card {
  background: var(--surface-2);
  border-color: var(--border);
}
[data-theme="dark"] .practice-card h3 {
  color: var(--text);
}
[data-theme="dark"] .file-input,
[data-theme="dark"] .search-input {
  background: var(--surface);
  color: var(--text);
  border-color: var(--border);
}
[data-theme="dark"] .file-input:hover {
  background: var(--surface-2);
}
[data-theme="dark"] .table-container {
  background: var(--surface);
  border-color: var(--border);
}
[data-theme="dark"] .table-controls,
[data-theme="dark"] .table-footer {
  background: var(--surface-2);
  border-color: var(--border);
}
[data-theme="dark"] .data-table th {
  background: var(--surface-2);
  color: var(--text);
  border-bottom-color: var(--border);
}
[data-theme="dark"] .data-table td {
  color: var(--text-muted);
  border-bottom-color: var(--border);
}
[data-theme="dark"] .data-table tr:hover,
[data-theme="dark"] .data-table tr:nth-child(even):hover {
  background: var(--surface-hover);
}
[data-theme="dark"] .data-table tr:nth-child(even) {
  background: var(--surface-2);
}

/* Mobile — desktop layout above unchanged */
@media (max-width: 768px) {
  .text-page-container {
    height: auto;
    min-height: calc(100vh - 64px);
    min-height: calc(100dvh - 64px);
    padding: 12px;
    overflow: visible;
  }

  .text-page-content {
    border-radius: 14px;
    padding: 14px;
    height: auto;
    min-height: calc(100dvh - 88px);
    overflow: visible;
  }

  .page-header {
    margin-bottom: 12px;
    padding-bottom: 12px;
    text-align: left;
  }

  .page-header h1 {
    font-size: 1.5rem;
  }

  .page-header p {
    font-size: 0.9375rem;
  }

  .data-section {
    padding: 12px;
    margin-bottom: 12px;
  }

  .table-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    padding: 12px 14px;
  }

  .table-header h3 {
    font-size: 1.05rem;
  }

  .table-controls {
    padding: 12px;
    gap: 8px;
  }

  .search-input {
    min-width: 0;
    max-width: none;
    width: 100%;
  }

  .table-wrapper {
    max-height: min(60vh, 480px);
    -webkit-overflow-scrolling: touch;
  }

  .data-table {
    min-width: 720px;
    font-size: 0.8125rem;
  }

  .data-table th,
  .data-table td {
    padding: 10px 12px;
    max-width: 180px;
  }

  .best-practices {
    grid-template-columns: 1fr;
  }

  .submit-button {
    width: 100%;
    align-self: stretch;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/incident-management/index.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,6DAA6D;EAC7D,4BAA4B;EAC5B,sBAAsB;EACtB,uFAAuF;EACvF,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,2CAA2C;EAC3C,0CAA0C;EAC1C,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,iDAAiD;EACjD,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,6DAA6D;EAC7D,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,0BAA0B;EAC1B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,iDAAiD;EACjD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yEAAyE;AAC3E;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,6DAA6D;EAC7D,4BAA4B;AAC9B;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;EACpC,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,6DAA6D;EAC7D,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,0CAA0C;EAC1C,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;EACnB,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;EACnB,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,6DAA6D;EAC7D,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,4DAA4D;AAC5D;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;;;;;EAKE,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,kCAAkC;AACpC;AACA;;EAEE,wBAAwB;AAC1B;AACA;;;;EAIE,4BAA4B;EAC5B,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,0BAA0B;EAC1B,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;;EAEE,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,kCAAkC;AACpC;AACA;EACE,wBAAwB;EACxB,kCAAkC;AACpC;AACA;;EAEE,gCAAgC;AAClC;AACA;EACE,4BAA4B;AAC9B;;AAEA,4CAA4C;AAC5C;EACE;IACE,YAAY;IACZ,8BAA8B;IAC9B,+BAA+B;IAC/B,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,+BAA+B;IAC/B,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,QAAQ;EACV;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,WAAW;EACb;;EAEA;IACE,4BAA4B;IAC5B,iCAAiC;EACnC;;EAEA;IACE,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;;IAEE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;AACF","sourcesContent":["/* Global resets to prevent overflow */\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  overflow-x: hidden;\n}\n\n.text-page-container {\n  width: 100%;\n  height: 100vh;\n  background: linear-gradient(135deg, #f8fafb 0%, #e8f0fe 100%);\n  padding: 24px 24px 24px 24px;\n  box-sizing: border-box;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.text-page-content {\n  background: rgba(255, 255, 255, 0.98);\n  backdrop-filter: blur(20px);\n  border-radius: 20px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);\n  border: 1px solid rgba(228, 232, 241, 0.6);\n  width: 100%;\n  height: 100%;\n  padding: 24px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.page-header {\n  margin-bottom: 16px;\n  padding-bottom: 16px;\n  border-bottom: 2px solid rgba(102, 126, 234, 0.1);\n  text-align: center;\n  flex-shrink: 0;\n}\n\n.page-header h1 {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: #1a202c;\n  margin: 0 0 12px 0;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.page-header p {\n  font-size: 1.1rem;\n  color: #64748b;\n  margin: 0;\n  font-weight: 500;\n}\n\n.content-section {\n  margin-bottom: 32px;\n}\n\n.content-section h2 {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #2d3748;\n  margin-bottom: 16px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.content-section p {\n  font-size: 1rem;\n  line-height: 1.7;\n  color: #4a5568;\n  margin-bottom: 16px;\n}\n\n.feature-list, .impact-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.feature-list li, .impact-list li {\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  border: 1px solid rgba(226, 232, 240, 0.6);\n  border-radius: 12px;\n  padding: 16px 20px;\n  margin-bottom: 12px;\n  font-size: 0.95rem;\n  line-height: 1.6;\n  color: #2d3748;\n  position: relative;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.feature-list li::before {\n  content: '✓';\n  position: absolute;\n  left: -8px;\n  top: 16px;\n  width: 24px;\n  height: 24px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 50%;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  font-size: 0.8rem;\n}\n\n.feature-list li:hover, .impact-list li:hover {\n  background: linear-gradient(135deg, #e6fffa 0%, #e0f2fe 100%);\n  border-color: #38b2ac;\n  transform: translateX(4px);\n  box-shadow: 0 4px 16px rgba(56, 178, 172, 0.15);\n}\n\n.impact-list li::before {\n  content: '→';\n  position: absolute;\n  left: -8px;\n  top: 16px;\n  width: 24px;\n  height: 24px;\n  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);\n  border-radius: 50%;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  font-size: 1rem;\n}\n\n.best-practices {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 20px;\n  margin-top: 20px;\n}\n\n.practice-card {\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  border-radius: 16px;\n  padding: 24px;\n  text-align: center;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  position: relative;\n  overflow: hidden;\n}\n\n.practice-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, #667eea 0%, #764ba2 50%, #f093fb 100%);\n}\n\n.practice-card:hover {\n  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);\n  border-color: #0ea5e9;\n  transform: translateY(-4px);\n  box-shadow: 0 8px 32px rgba(14, 165, 233, 0.15);\n}\n\n.practice-card h3 {\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #1a202c;\n  margin: 0 0 12px 0;\n}\n\n.practice-card p {\n  font-size: 0.9rem;\n  color: #64748b;\n  margin: 0;\n  line-height: 1.5;\n}\n\n/* Scrollbar Styles */\n.text-page-content::-webkit-scrollbar {\n  width: 8px;\n}\n\n.text-page-content::-webkit-scrollbar-track {\n  background: transparent;\n  border-radius: 10px;\n}\n\n.text-page-content::-webkit-scrollbar-thumb {\n  background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);\n  border-radius: 10px;\n  border: 2px solid transparent;\n  background-clip: content-box;\n}\n\n.text-page-content::-webkit-scrollbar-thumb:hover {\n  background: linear-gradient(135deg, #cbd5e1 0%, #94a3b8 100%);\n  background-clip: content-box;\n}\n\n/* Upload Section Styles */\n.upload-section {\n  margin-bottom: 32px;\n  padding: 24px;\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  border-radius: 16px;\n  border: 1px solid rgba(226, 232, 240, 0.8);\n}\n\n.upload-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.file-input-container {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.file-label {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #2d3748;\n  margin-bottom: 8px;\n}\n\n.file-input {\n  padding: 12px 16px;\n  border: 2px dashed #cbd5e1;\n  border-radius: 12px;\n  background: white;\n  font-size: 0.9rem;\n  color: #4a5568;\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.file-input:hover {\n  border-color: #667eea;\n  background: #f8fafc;\n}\n\n.file-input:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.file-name {\n  font-size: 0.9rem;\n  color: #667eea;\n  font-weight: 500;\n  padding: 8px 12px;\n  background: rgba(102, 126, 234, 0.1);\n  border-radius: 8px;\n  display: inline-block;\n}\n\n.submit-button {\n  padding: 14px 28px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  border-radius: 12px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  align-self: flex-start;\n}\n\n.submit-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 32px rgba(102, 126, 234, 0.3);\n}\n\n.submit-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.error-message {\n  color: #e53e3e;\n  background: #fed7d7;\n  padding: 12px 16px;\n  border-radius: 8px;\n  border: 1px solid #feb2b2;\n  font-size: 0.9rem;\n  margin-top: 12px;\n}\n\n.loading-container {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px;\n  background: linear-gradient(135deg, #e0f2fe 0%, #b3e5fc 100%);\n  border-radius: 8px;\n  margin-top: 12px;\n}\n\n.loading-spinner {\n  width: 20px;\n  height: 20px;\n  border: 2px solid #e2e8f0;\n  border-top: 2px solid #667eea;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Table Styles */\n.table-container {\n  background: white;\n  border-radius: 16px;\n  border: 1px solid #e2e8f0;\n  overflow: hidden;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n\n\n.table-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  flex-shrink: 0;\n}\n\n.table-header h3 {\n  margin: 0;\n  font-size: 1.3rem;\n  font-weight: 600;\n}\n\n.record-count {\n  font-size: 0.9rem;\n  background: rgba(255, 255, 255, 0.2);\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-weight: 500;\n}\n\n.table-controls {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 20px;\n  background: #f8fafc;\n  border-bottom: 1px solid #e2e8f0;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  width: 100%;\n  max-width: 100%;\n}\n\n.search-input {\n  padding: 8px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  width: 100%;\n  max-width: 300px;\n  min-width: 200px;\n  background: white;\n  transition: border-color 0.2s ease;\n}\n\n.search-input:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.record-info {\n  font-size: 0.9rem;\n  color: #64748b;\n  font-weight: 500;\n}\n\n.table-wrapper {\n  flex: 1;\n  overflow: auto;\n  min-height: 0;\n  max-height: 100%;\n}\n\n/* Custom scrollbar for table wrapper */\n.table-wrapper::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n.table-wrapper::-webkit-scrollbar-track {\n  background: #f1f5f9;\n  border-radius: 4px;\n}\n\n.table-wrapper::-webkit-scrollbar-thumb {\n  background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);\n  border-radius: 4px;\n}\n\n.table-wrapper::-webkit-scrollbar-thumb:hover {\n  background: linear-gradient(135deg, #cbd5e1 0%, #94a3b8 100%);\n}\n\n.data-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.9rem;\n  table-layout: auto;\n}\n\n.data-table th {\n  background: #f8fafc;\n  color: #2d3748;\n  font-weight: 600;\n  padding: 12px 16px;\n  text-align: left;\n  border-bottom: 2px solid #e2e8f0;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  white-space: nowrap;\n  vertical-align: middle;\n  box-sizing: border-box;\n  max-width: 150px;\n  text-transform: none;\n}\n\n.data-table td {\n  padding: 12px 16px;\n  border-bottom: 1px solid #f1f5f9;\n  color: #4a5568;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  vertical-align: middle;\n  text-align: left;\n  box-sizing: border-box;\n  max-width: 150px;\n}\n\n.data-table th,\n.data-table td {\n  border-left: none;\n  border-right: none;\n}\n\n.data-table tr:hover {\n  background: #f8fafc;\n}\n\n.data-table tr:nth-child(even) {\n  background: #fafbfc;\n}\n\n.data-table tr:nth-child(even):hover {\n  background: #f1f5f9;\n}\n\n.table-footer {\n  padding: 16px 24px;\n  background: #f8fafc;\n  color: #64748b;\n  font-size: 0.9rem;\n  text-align: center;\n  border-top: 1px solid #e2e8f0;\n}\n\n.no-data {\n  padding: 40px;\n  text-align: center;\n  color: #64748b;\n  font-size: 1rem;\n}\n\n/* Data Section Styles */\n.data-section {\n  margin-bottom: 16px;\n  padding: 16px;\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  border-radius: 16px;\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  flex-shrink: 0;\n}\n\n.success-message {\n  color: #065f46;\n  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);\n  padding: 16px 20px;\n  border-radius: 12px;\n  border: 1px solid #6ee7b7;\n  font-size: 0.95rem;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.success-message::before {\n  content: '✓';\n  width: 20px;\n  height: 20px;\n  background: #059669;\n  border-radius: 50%;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  font-size: 0.8rem;\n  flex-shrink: 0;\n}\n\n/* ===== Dark theme overrides (light mode untouched) ===== */\n[data-theme=\"dark\"] .text-page-container {\n  background: var(--app-bg);\n}\n[data-theme=\"dark\"] .text-page-content {\n  background: var(--surface);\n  border-color: var(--border);\n}\n[data-theme=\"dark\"] .page-header p,\n[data-theme=\"dark\"] .practice-card p,\n[data-theme=\"dark\"] .record-info,\n[data-theme=\"dark\"] .table-footer,\n[data-theme=\"dark\"] .no-data {\n  color: var(--text-muted);\n}\n[data-theme=\"dark\"] .content-section h2 {\n  color: var(--text);\n  border-bottom-color: var(--border);\n}\n[data-theme=\"dark\"] .content-section p,\n[data-theme=\"dark\"] .file-label {\n  color: var(--text-muted);\n}\n[data-theme=\"dark\"] .feature-list li,\n[data-theme=\"dark\"] .impact-list li,\n[data-theme=\"dark\"] .upload-section,\n[data-theme=\"dark\"] .data-section {\n  background: var(--surface-2);\n  border-color: var(--border);\n  color: var(--text);\n}\n[data-theme=\"dark\"] .practice-card {\n  background: var(--surface-2);\n  border-color: var(--border);\n}\n[data-theme=\"dark\"] .practice-card h3 {\n  color: var(--text);\n}\n[data-theme=\"dark\"] .file-input,\n[data-theme=\"dark\"] .search-input {\n  background: var(--surface);\n  color: var(--text);\n  border-color: var(--border);\n}\n[data-theme=\"dark\"] .file-input:hover {\n  background: var(--surface-2);\n}\n[data-theme=\"dark\"] .table-container {\n  background: var(--surface);\n  border-color: var(--border);\n}\n[data-theme=\"dark\"] .table-controls,\n[data-theme=\"dark\"] .table-footer {\n  background: var(--surface-2);\n  border-color: var(--border);\n}\n[data-theme=\"dark\"] .data-table th {\n  background: var(--surface-2);\n  color: var(--text);\n  border-bottom-color: var(--border);\n}\n[data-theme=\"dark\"] .data-table td {\n  color: var(--text-muted);\n  border-bottom-color: var(--border);\n}\n[data-theme=\"dark\"] .data-table tr:hover,\n[data-theme=\"dark\"] .data-table tr:nth-child(even):hover {\n  background: var(--surface-hover);\n}\n[data-theme=\"dark\"] .data-table tr:nth-child(even) {\n  background: var(--surface-2);\n}\n\n/* Mobile — desktop layout above unchanged */\n@media (max-width: 768px) {\n  .text-page-container {\n    height: auto;\n    min-height: calc(100vh - 64px);\n    min-height: calc(100dvh - 64px);\n    padding: 12px;\n    overflow: visible;\n  }\n\n  .text-page-content {\n    border-radius: 14px;\n    padding: 14px;\n    height: auto;\n    min-height: calc(100dvh - 88px);\n    overflow: visible;\n  }\n\n  .page-header {\n    margin-bottom: 12px;\n    padding-bottom: 12px;\n    text-align: left;\n  }\n\n  .page-header h1 {\n    font-size: 1.5rem;\n  }\n\n  .page-header p {\n    font-size: 0.9375rem;\n  }\n\n  .data-section {\n    padding: 12px;\n    margin-bottom: 12px;\n  }\n\n  .table-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n    padding: 12px 14px;\n  }\n\n  .table-header h3 {\n    font-size: 1.05rem;\n  }\n\n  .table-controls {\n    padding: 12px;\n    gap: 8px;\n  }\n\n  .search-input {\n    min-width: 0;\n    max-width: none;\n    width: 100%;\n  }\n\n  .table-wrapper {\n    max-height: min(60vh, 480px);\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .data-table {\n    min-width: 720px;\n    font-size: 0.8125rem;\n  }\n\n  .data-table th,\n  .data-table td {\n    padding: 10px 12px;\n    max-width: 180px;\n  }\n\n  .best-practices {\n    grid-template-columns: 1fr;\n  }\n\n  .submit-button {\n    width: 100%;\n    align-self: stretch;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
